<template>
  <div>
    <label for="preparationInSitu">Sample preparation in situ</label>
    <extended-radio-group id="preparationInSitu"
                          v-model="valueFromProp.preparation_in_situ"
                          :disabled="disabled"
                          :isInvalid="isPreparationInSituInvalid"
                          :options="yesNo"/>
    <div v-if="valueFromProp.preparation_in_situ" class="mb-2">
      <b-row class="mb-2">
        <b-col>
          <p class="p-form-label">Sample preparation temperature range
            <span class="grey--text">
              ({{ beamlineSpecification.sample_temperature_in_situ.temperature_range_from }} -
              {{ beamlineSpecification.sample_temperature_in_situ.temperature_range_to }} K)
            </span>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input-group :class="{'custom-invalid-input-border custom-input-border-radius': validateInput('fromInput')}"
                         append="K"
                         prepend="from"
                         @input="isPreparationTemperatureFromInvalid.$touch()">
            <b-form-input v-model="valueFromProp.preparation_temperature_from"
                          :disabled="disabled"
                          :max="beamlineSpecification.sample_temperature_in_situ.temperature_range_to"
                          :min="beamlineSpecification.sample_temperature_in_situ.temperature_range_from"
                          type="number"
                          @paste.prevent/>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group :class="{'custom-invalid-input-border custom-input-border-radius': validateInput('toInput')}"
                         append="K"
                         prepend="to"
                         @input="isPreparationTemperatureToInvalid.$touch()">
            <b-form-input v-model="valueFromProp.preparation_temperature_to"
                          :disabled="disabled"
                          :max="beamlineSpecification.sample_temperature_in_situ.temperature_range_to"
                          :min="beamlineSpecification.sample_temperature_in_situ.temperature_range_from"
                          type="number"
                          @paste.prevent/>
          </b-input-group>
        </b-col>
      </b-row>

      <div v-if="hasDescriptionOfPreparation">
        <label for="descriptionOfStepsForPreparationInSitu">Description of steps for sample preparation in-situ</label>
        <b-form-textarea id="descriptionOfStepsForPreparationInSitu"
                         v-model="valueFromProp.description_of_steps_for_preparation_in_situ"
                         :class="{'custom-invalid-input-border custom-input-border-radius': validateInput('descriptionOfStepsForPreparationInSituInput')}"
                         :placeholder="descriptionOfStepsForPreparationInSituPlaceholder"
                         :readonly="disabled"
                         rows="3"
                         @input="isDescriptionOfStepsForPreparationInSituInvalid.$touch()"/>
      </div>
    </div>
  </div>
</template>

<script>
  import ExtendedRadioGroup from '@/components/ExtendedRadioGroup';
  import yesNo from '@/json/radioButtonYesNo';

  export default {
    name: 'PreparationInSitu',
    components: { ExtendedRadioGroup },
    props: {
      value: {
        type: Object,
        default() {
          return {};
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hasDescriptionOfPreparation: {
        type: Boolean,
        default: false,
      },
      isPreparationInSituInvalid: {
        type: Object,
        default: () => ({
          $error: false,
          $touch() { /* Nothing to be done here */
          },
        }),
      },
      isPreparationTemperatureFromInvalid: {
        type: Object,
        default: () => ({
          $error: false,
          $touch() { /* Nothing to be done here */
          },
        }),
      },
      isPreparationTemperatureToInvalid: {
        type: Object,
        default: () => ({
          $error: false,
          $touch() { /* Nothing to be done here */
          },
        }),
      },
      isDescriptionOfStepsForPreparationInSituInvalid: {
        type: Object,
        default: () => ({
          $error: false,
          $touch() { /* Nothing to be done here */
          },
        }),
      },
      beamlineSpecification: {},
    },
    data() {
      return {
        valueFromProp: this.value,
        yesNo,
        descriptionOfStepsForPreparationInSituPlaceholder: 'Enter missing value',
      };
    },
    methods: {
      validateInput(input) {
        if (input === 'fromInput') {
          if (this.valueFromProp.preparation_temperature_to === undefined) {
            return this.isPreparationTemperatureFromInvalid.$error
              && this.isPreparationTemperatureToInvalid.$dirty;
          }
          return this.isPreparationTemperatureFromInvalid.$error;
        }
        if (input === 'toInput') {
          if (this.valueFromProp.preparation_temperature_from === undefined) {
            return this.isPreparationTemperatureToInvalid.$error
              && this.isPreparationTemperatureFromInvalid.$dirty;
          }
          return this.isPreparationTemperatureToInvalid.$error;
        }
        if (input === 'descriptionOfStepsForPreparationInSituInput') {
          if (!this.description_of_steps_for_preparation_in_situ) {
            return this.isDescriptionOfStepsForPreparationInSituInvalid.$error;
          }
        }
        return false;
      },
    },
    watch: {
      valueFromProp() {
        this.$emit('input', this.valueFromProp);
      },
      'valueFromProp.preparation_in_situ': {
        handler() {
          if (!this.valueFromProp.preparation_in_situ) {
            delete this.valueFromProp.preparation_temperature_from;
            delete this.valueFromProp.preparation_temperature_to;
            delete this.valueFromProp.description_of_steps_for_preparation_in_situ;
          }
        },
      },
      value() {
        this.valueFromProp = this.value;
      },
    },
  };
</script>
